import request from '@/utils/request'

export function getJmReportMenuTree(menuId) {
  return request({
    url: '/api/sys-service/menu/tree',
    method: 'get',
    params: { menuId }
  })
}
